import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import { setOuterHTML, throttle } from 'next/javascripts/modules/utils';
import { closest } from 'next/javascripts/modules/dom';
import { observe, unobserve, isIntersecting } from './intersection-observer';
import Group from './group';

let loadRequest;

Component('tr-grid-todo-group', {
  extends: [Group],

  properties: {
    firstPageLoaded: {
      type: Boolean,
      default: false,
      observer: 'firstPageLoadedChanged',
    },

    loadUrl: String,

    loading: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.detectEmpty();
  },

  ready() {
    this.listenTo(
      this,
      'tr-scroll-load-trigger:loading',
      this.loadNextPage.bind(this),
    );

    this.listenTo(this, {
      'tr-grid-todo-row:expandRow': () => {
        this.summary();
      },
      'tr-grid-todo-row:afterConnected': throttle(() => {
        this.summary();
        this.detectEmpty();
      }, 100),
      'tr-grid-todo-row:beforeDisconnected': throttle(() => {
        setTimeout(() => {
          this.summary();
          this.detectEmpty();
        }, 10);
      }, 100),
    });
  },

  initIntersectionObserver() {
    observe(this, 'tr-grid-todo-group', this.handleIntersection.bind(this), {
      root: closest(this, 'tr-todo-grid .grid-vertical-scrollable'),
      rootMargin: '500px 0px 500px 0px',
    });
  },

  handleIntersection(entry) {
    if (isIntersecting(entry) && this.loadFirstPage()) {
      unobserve(this, 'tr-grid-todo-group');
    }
  },

  loadFirstPage() {
    if (!this.loadUrl || this.firstPageLoaded) return true;
    if (loadRequest) return false;

    this.loading = true;
    loadRequest = $.ajax({
      url: this.loadUrl,
      method: 'get',
      data: { group_value: this.value },
      dataType: 'script',
    }).then(() => {
      this.firstPageLoaded = true;
      this.loading = false;
      loadRequest = null;
    });

    return loadRequest;
  },

  loadNextPage() {
    const scrollLoadTrigger = this.querySelector('tr-scroll-load-trigger');
    if (!this.loadUrl || loadRequest || !this.expanded) {
      scrollLoadTrigger.loading = false;
      return;
    }

    if (this.loading === true) {
      return;
    }

    const { latestOffset, paginationOffset } = scrollLoadTrigger.dataset;
    if (!latestOffset && !paginationOffset) return;

    this.loading = true;
    loadRequest = $.ajax({
      url: this.loadUrl,
      method: 'get',
      data: {
        group_value: this.value,
        latest_offset: latestOffset,
        pagination_offset: paginationOffset,
      },
      dataType: 'script',
    }).then(() => {
      loadRequest = null;
      // set false when dom has been updated(in ejs file)
      // otherwise it could trigger request multi-times
      //
      // this.loading = false;
    });
  },

  appendTodoRows(rows) {
    const scrollLoadTrigger = this.querySelector('.scroll-loading-row');

    if (scrollLoadTrigger) {
      setOuterHTML(scrollLoadTrigger, rows);
    } else {
      this.querySelector('.group-content').insertAdjacentHTML('afterbegin', rows);
    }

    this.firstPageLoaded = true;
  },

  firstPageLoadedChanged(firstPageLoaded) {
    if (!firstPageLoaded) return;

    const scrollLoadTrigger = this.querySelector('tr-scroll-load-trigger');
    if (!scrollLoadTrigger || scrollLoadTrigger.dataset.latestOffset) return;

    const container = closest(scrollLoadTrigger, '.scroll-loading-row');
    container.parentNode.removeChild(container);
  },

  handleAfterCreate() {
    this.namespacedTrigger('newTodoGroupCreated', { bubbles: true });
    this.insertNewTodo();
  },

  insertNewTodo() {
    this.querySelector('.new-todo-button').click();
  },

  detectEmpty() {
    this.rowsNum = this.querySelectorAll('tr-grid-todo-row').length;

    if (this.rowsNum === 0) {
      this.classList.add('grid-group-empty');
    } else {
      this.classList.remove('grid-group-empty');
    }

    return this.rowsNum;
  },

  toggleSummaryCell(key, hidden) {
    const cell = this.summaryRow.querySelector(`.grid-summary-cell[target="${key}"]`);
    if (cell) cell.classList.toggle('hidden', hidden);
  },

  disconnected() {
    unobserve(this, 'tr-grid-todo-group');
    this.stopListening();
  },
});
